<template>
    <section>
        <template v-if="options && options.showCPC">
            <h3 class="f3 text-bold">Calculate Your Monthly Payment</h3>
            <mvtMortgage
                ref="mortgageComponent"
                @loanPerMonthChanged="loanPerMonthChanged"
                @monthTotalChanged="monthTotalChanged"
                @loanDescription="updateDescription"
                :state="dpp.geo.state"
                :city="dpp.geo.city"
                :zipcode="dpp.geo.zipcode"
                :address="dpp.geo.address"
                :subPremise="dpp.geo.subPremise"
                :propertyType="dpp.propertyType"
                :price="dpp.price"
                :isActive="dpp.isActive"
                :isOjOBrokerage="dpp.isOjOBrokerage"
                :houseRealStatus="dpp.houseRealStatus"
                :loadBankrateLink="dpp.loadBankrateLink"
                :daysOnMovoto="dpp.daysOnMovoto"
                :propertyId="dpp.propertyId"
                :hoafee="dpp.hoafee"
                :path="dpp.path"
                :showCPC="options && options.showCPC"
                :showDataSource="showDataSource()" />
            <div class="cpc-3way-payment grid xs-grid-cols-1 m-t-3">
                <button class="btn primary large" @click="show3rdPartyForm">{{molang('dpp.propertyDetails.getPrequalified')}}</button>
                <button class="btn secondary large" @click="openHotleadForm">{{molang('dpp.propertyDetails.meetAgent')}}</button>
            </div>
        </template>
        <template v-else-if="options && options.showRefinance">
            <div class="grid xs-grid-cols-1 text-center">
                <template  v-if="options && options.showNewTitle">
                    <h3 class="f3 text-bold text-center">
                        Thanks! We will call you soon.
                    </h3>
                    <div>Be prepared to make offers, get preapproved today.</div>
                </template>
                <template>
                    <div>Get preapproved for a mortgage on this property</div>
                </template>
            </div>
            <mvtMortgage
                ref="mortgageComponent"
                @loanPerMonthChanged="loanPerMonthChanged"
                @monthTotalChanged="monthTotalChanged"
                @loanDescription="updateDescription"
                :state="dpp.geo.state"
                :city="dpp.geo.city"
                :zipcode="dpp.geo.zipcode"
                :address="dpp.geo.address"
                :subPremise="dpp.geo.subPremise"
                :propertyType="dpp.propertyType"
                :price="dpp.price"
                :isActive="dpp.isActive"
                :isOjOBrokerage="dpp.isOjOBrokerage"
                :houseRealStatus="dpp.houseRealStatus"
                :loadBankrateLink="dpp.loadBankrateLink"
                :daysOnMovoto="dpp.daysOnMovoto"
                :propertyId="dpp.propertyId"
                :hoafee="dpp.hoafee"
                :path="dpp.path"
                :showRefinance="options && options.showRefinance"
                :showCheckScore="options && options.showNewTitle"
                :pid="options && options.pid"
                :triggerId="options && options.triggerId"
                :cta="options && options.cta"
                :showDataSource="showDataSource()" />
        </template>
        <mvtCollapse v-else :isActive="getIsActive" :disable="disableCollapse" v-on:open="openMortgageComponent" v-on:close="closePaymentSection">
            <template v-slot:header="collapsible">
                <h2 class="f4 text-bold singleline">{{ getSectionTitle }}</h2>
                <div class="f7 text-gray singleline" v-show="collapsible.collapsed">{{description}}</div>
            </template>
            <template v-slot:default>
                <div class="property-mortgage grid xs-grid-cols-1">
                    <mvtMortgage
                    ref="mortgageComponent"
                    @loanPerMonthChanged="loanPerMonthChanged"
                    @monthTotalChanged="monthTotalChanged"
                    @loanDescription="updateDescription"
                    :state="dpp.geo.state"
                    :city="dpp.geo.city"
                    :zipcode="dpp.geo.zipcode"
                    :address="dpp.geo.address"
                    :subPremise="dpp.geo.subPremise"
                    :propertyType="dpp.propertyType"
                    :price="dpp.price"
                    :isActive="dpp.isActive"
                    :isOjOBrokerage="dpp.isOjOBrokerage"
                    :houseRealStatus="dpp.houseRealStatus"
                    :loadBankrateLink="dpp.loadBankrateLink"
                    :daysOnMovoto="dpp.daysOnMovoto"
                    :propertyId="dpp.propertyId"
                    :hoafee="dpp.hoafee"
                    :yearBuilt="dpp.yearBuilt"
                    :path="dpp.path"
                    :showDataSource="showDataSource()" />

                    <dppCtaCard id="dppCtaCard" v-if="dpp.isActive" :dppCtaInfo="{title: molang('dpp.propertyMortgage.ctaTitle'),
                    sub: molang('dpp.propertyMortgage.ctaSub'),
                    cta: molang('dpp.sellbanner.connectNow'),
                    icon: 'icon-calculator',
                    hotleadType: 'PaymentCalcDPP',
                    section: 'Payment Calculator'}"/>
                </div>
            </template>
        </mvtCollapse>
    </section>
</template>
<script src="./property-mortgage.js"></script>

<style lang="scss">
@use "./property-mortgage.scss" as *;
</style>
